exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#chartdivGender[data-v-374e867f]{width:100%;height:500px}", ""]);

// exports
